export { initialiseFeatureGates } from './statsig-initialisation';
